import React, { useState, useContext } from "react";
// import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
// import { useHistory } from "react-router-dom";
import VideoRecorder from "react-video-recorder";
import * as Sentry from "@sentry/react";
import { Hidden } from "@material-ui/core";
import { CoinContext } from "../../contexts/CoinContext";
import { REACT_APP_PROD_URL } from "../../services/configs";
import { useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher";

// const useStyles = makeStyles((theme) => ({}));

export default function ReactVideoRec(props) {
  // const classes = useStyles();
  // const theme = useTheme();
  // let history = useHistory();

  const token = useSelector((state) => state.trading.TOKEN);

  const { handleClickAlert } = useContext(CoinContext);

  const [recording, setRecording] = useState(false);
  const [otp, setOtp] = useState("");
  const [vidData, setVidData] = useState(null);
  const [uploadButton, setUploadButton] = useState(false);

  const [doubleClick, setDoubleClick] = useState(false);

  function getVideoOtp() {
    if (token) {
      fetcher(`/v1/um/getKycOtp`)
        .then((data) => {
          setOtp(data.otp);
          // console.log(data);
        })
        .catch((err) => {
          // console.error(err);
          handleClickAlert("error", "Failed to fetch OTP, please try again");
          console.error(err);
        });
    }
  }

  function sendVideo() {
    if (token && vidData) {
      var formData = new FormData();
      formData.append("video", vidData);
      // console.log(vidData);

      fetcher(`/v1/um/kyc-step-4`, {
        method: "POST",
        body: formData,
        type: "formData",
      })
        .then((res) => {
          handleClickAlert("success", "Video uploaded successfully");
          props.vidDone(true);
          setDoubleClick(false);
          // console.log(res);
        })
        .catch((err) => {
          handleClickAlert("error", "Failed to upload video, please try again");
          setDoubleClick(false);
          console.error(err);
          // console.log(err.response.request._response);
        });

      // console.log("Submitting video selfie");
    } else {
      handleClickAlert("error", "Failed to upload video, please try again");
      setDoubleClick(false);
    }
  }

  return (
    <div>
      {recording ? (
        <ol
          style={{
            fontSize: "16px",
            paddingLeft: "18px",
            paddingBottom: "10px",
            fontWeight: "bold",
          }}
        >
          <li>Say each digit out loud: {otp ? otp : "Loading"}</li>
          <li>
            I, {props.name} want to trade Bitcoin and other crypto assets on
            PocketBits.
          </li>
        </ol>
      ) : null}

      <Hidden mdUp>
        {/* {!recording && (
          <Button
            color="primary"
            variant="contained"
            style={{ marginTop: "10px", color: "white", fontWeight: "bold" }}
            onClick={() => {
              getVideoOtp();
              setRecording(true);
            }}
          >
            Get OTP
          </Button>
        )} */}
        <VideoRecorder
          timeLimit={30000}
          constraints={{
            audio: true,
            video: {
              width: { min: 852 },
              height: { min: 400 },
            },
          }}
          onTurnOnCamera={() => {
            getVideoOtp();
            setRecording(true);
          }}
          onRecordingComplete={(videoBlob) => {
            // Do something with the video...
            // console.log("videoBlob", videoBlob);
            setUploadButton(true);
            // vid size for 30 secs is 12164854
            if (videoBlob.size < 12164954) {
              setVidData(videoBlob);
            } else {
              alert("The video exceeeded the size limit.");
            }
          }}
        />
      </Hidden>

      <Hidden smDown>
        <VideoRecorder
          timeLimit={30000}
          constraints={{
            audio: true,
            video: {
              width: { min: 852 },
              height: { min: 400 },
            },
          }}
          onTurnOnCamera={() => {
            getVideoOtp();
            setRecording(true);
            setUploadButton(false);
          }}
          onRecordingComplete={(videoBlob) => {
            // Do something with the video...
            // console.log(videoBlob);
            setVidData(videoBlob);
          }}
          onStopRecording={() => {
            setRecording(false);
            setUploadButton(true);
            setOtp("");
          }}
        />
      </Hidden>

      {uploadButton ? (
        <Button
          color="primary"
          variant="contained"
          style={{ marginTop: "10px", color: "white", fontWeight: "bold" }}
          onClick={() => {
            setDoubleClick(true);
            sendVideo();
          }}
          disabled={doubleClick}
        >
          Upload Video
        </Button>
      ) : null}
    </div>
  );
}
